/**
 * true = session from HttpOnly cookies only (`withCredentials`); no JWT in localStorage/sessionStorage.
 * GET `/api/auth/me` restores user after refresh.
 * false = legacy JWT in sessionStorage + Bearer header (local dev only).
 */
export const AUTH_USE_HTTPONLY_COOKIE = true;
